import { InputActionMeta } from 'react-select';
import { isDefined } from 'utils/tsHelpers';
import { delimiter as pasteDelimiter } from '../constants';

export const getAdditionalMultiValueProps = (
  isMultiInput?: boolean,
  setSearch?: (input: string) => void,
  search: string = '',
) => {
  return {
    ...(isMultiInput && { canCreate: true, canBulkPaste: true, pasteDelimiter }),
    ...(setSearch &&
      isDefined(search) && {
        onInputChange: (inputValue: string, actionMeta?: InputActionMeta) => {
          // Prevents other react-select actions from setting search
          if (actionMeta?.action === 'set-value') {
            setSearch(search);
            return search;
          } else {
            setSearch(inputValue);
            return inputValue;
          }
        },
        inputValue: search,
      }),
  };
};
